import { render, staticRenderFns } from "./taskBrokerageCount.vue?vue&type=template&id=2deb86ad&scoped=true"
import script from "./taskBrokerageCount.vue?vue&type=script&lang=js"
export * from "./taskBrokerageCount.vue?vue&type=script&lang=js"
import style0 from "./taskBrokerageCount.vue?vue&type=style&index=0&id=2deb86ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deb86ad",
  null
  
)

export default component.exports